import { render, staticRenderFns } from "./DraggableListsMobileLayersItem.vue?vue&type=template&id=4e819b88&scoped=true&"
import script from "./DraggableListsMobileLayersItem.vue?vue&type=script&lang=js&"
export * from "./DraggableListsMobileLayersItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsMobileLayersItem.vue?vue&type=style&index=0&id=4e819b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e819b88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTooltip})
